// extracted by mini-css-extract-plugin
module.exports = {"productTitle":"AccessPermissionsTableRow_productTitle__21W14","checkbox":"AccessPermissionsTableRow_checkbox__oyJ16"};